import { WarningIcon } from "components/ui/Icons/WarningIcon";
import { Button } from "components/ui/legacy/Button";
import { Typography } from "components/ui/Typography";
import { cn } from "lib/utils/cn";
import { useTranslation } from "react-i18next";

import { Link } from "../Link";

export const AccessDeniedView: FC = ({ className, ...restProps }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "common.accessDenied" });

  return (
    <div className={cn("flex flex-col items-center justify-center gap-5 h-full w-full", className)} data-testid="access-denied-view" {...restProps}>
      <div className="flex flex-col items-center justify-center gap-1 max-w-118">
        <WarningIcon size={40} />
        <Typography variant="title_sb">{t("title")}</Typography>
        <Typography className="text-center">{t("description")}</Typography>
      </div>

      <Link to="/">
        <Button data-testid="access-denied-home-button" size="medium">{t("goToHomeScreen")}</Button>
      </Link>
    </div>
  );
};
